import { render, staticRenderFns } from "./extendColumn.vue?vue&type=template&id=8547af52&"
import script from "./extendColumn.vue?vue&type=script&lang=js&"
export * from "./extendColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports